import { styled } from "@mui/material/styles";
const PreviewOrderMain = styled("div")(({ theme }) => ({
  marginTop: "35px",
  paddingBottom: "40px",
  [theme.breakpoints.down("md")]: {
    paddingBottom: "30px",
  },
}));
const PreviewOrderHeader = styled("div")(({ theme }) => ({
  textAlign: "center",
  "& h6": {
    fontFamily: theme.typography.fontFamily,
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "32px",
    lineHeight: "44px",
    textAlign: "center",
    color: theme.palette.colors.BlackBean,
  },
  "& p": {
    fontFamily: theme.typography.fontFamily,
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "22px",
    lineHeight: "30px",
    textAlign: "center",
    color: "rgba(11, 11, 11, 0.5)",
  },
  [theme.breakpoints.down("md")]: {
    "& img": { display: "bolck" },
    "& h6": {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "16px",
      marginBottom: "5px",
    },
    "& p": {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "16px",
      color: "#191D31",
    },
  },
  [theme.breakpoints.up("md")]: {
    "& img": { display: "none" },
  },
}));

const OrderSteps = styled("div")(({ theme }) => ({
  width: "80%",
  margin: "auto",
  marginTop: "30px",
  "& ul": { listStyle: "none" },
  "& li": {
    borderBottom: "2px solid #F3F3F3",
    padding: "15px 0",
    position: "relative",
    counterIncrement: "list",
    "&::before": {
      content: '""',
      position: "absolute",
      left: "-1.7rem",
      top: "70%",
      height: "44%",
      width: "1px",
      borderLeft: "2px dashed rgba(11, 11, 11, 0.5)",
    },
    "&::after": {
      content: '"1"',
      position: "absolute",
      top: "20px",
      left: "-2.5rem",
      width: "26px",
      height: "26px",
      borderRadius: "50%",
      background: "transparent",
      fontWeight: 400,
      fontSize: "13px",
      lineHeight: "2rem",
      textAlign: "center",
      border: "2px solid  #0B0B0B",
      color: "#0B0B0B",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  "& li:nth-of-type(2)": {
    "&::after": {
      content: '"2"',
    },
  },
  "& li:nth-of-type(3)": {
    "&::after": {
      content: '"3"',
    },
  },
  "& li:nth-of-type(4)": {
    "&::after": {
      content: '"4"',
    },
  },

  "& li:last-child": {
    borderBottom: "none",
    "&::before": {
      content: "none",
    },
  },
  "& .OrderStepsMian": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  "& h6": {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "30px",
    color: theme.palette.colors.BlackBean,
    fontFamily: theme.typography.fontFamily,
  },
  "& p": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "130%",
    color: "rgba(11, 11, 11, 0.6)",
    fontFamily: theme.typography.fontFamily,
  },
  "& span": {
    width: "88px",
    height: "43px",
    background: "#56A4FF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50px",
    color: "#FFFFFF",
    fontFamily: theme.typography.fontFamily,
  },
  "& span.Dropoff": {
    background: "#52D104",
  },

  [theme.breakpoints.down("md")]: {
    width: "90%",
    marginLeft: "auto",
    "& h6": {
      fontSize: "14px",
    },
    "& p": {
      fontSize: "14px",
    },
    "& span": {
      width: "52px",
      height: "22px",
      fontSize: "10px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    "& li::before": {
      left: "-0.9rem",
    },
    "& li::after": {
      left: "-1.5rem",
      width: "20px",
      height: "20px",
    },
  },
}));

const OrderButtonMain = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "20px",
  marginTop: "20px",
  flexDirection: "row",
  [theme.breakpoints.down("md")]: {
    gap: "5px",
    flexDirection: "column-reverse",
    "& button:first-of-type": {
      marginTop: "10px",
    },
  },
}));

export { PreviewOrderMain, PreviewOrderHeader, OrderSteps, OrderButtonMain };
